/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseContactList } from '../../models/api-response-contact-list';

export interface GetContactList$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
}

export function getContactList(http: HttpClient, rootUrl: string, params: GetContactList$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactList>> {
  const rb = new RequestBuilder(rootUrl, getContactList.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseContactList>;
    })
  );
}

getContactList.PATH = '/v1/api/ui/contactList/{ref}';
